export default {
	default: [''],
	leftLabel: ['input--left-label']
};
